/**
 * Enum rodzajów ważności karty
 *
 * @export
 * @enum {number}
 */
export var CardExpirationType;
(function (CardExpirationType) {
    CardExpirationType["ANNUAL"] = "ANNUAL";
    CardExpirationType["UNLIMITED"] = "UNLIMITED";
})(CardExpirationType || (CardExpirationType = {}));
export const CardExpirationTypeTranslation = {
    [CardExpirationType.ANNUAL]: 'Rok',
    [CardExpirationType.UNLIMITED]: 'Bezterminowo'
};
//# sourceMappingURL=cardExpirationType.enum.js.map